export default {
    getStoredDropdowns: (state) => {
        return state.dropdowns
    },
    getStoredDropdown: (state) => {
        return state.dropdown
    },
    getStoredNewStaticSite: (state) => {
        return state.newStaticSite
    },
    getStoredSites: (state) => {
        return state.sites
    },
    getStoredSite: (state) => {
        return state.site
    },
    getStoredSections: (state) => {
        return state.sections
    },
    getStoredSection: (state) => {
        return state.section
    },
    getDropdownState: (state) => {
        return state.dropdownsState
    },
    getSitesState: (state) => {
        return state.sitesState
    },
    getSectionsState: (state) => {
        return state.sectionsState
    },
}
